import routerOptions0 from "/opt/bookandgolf-front/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.15.3_better-sqlite3@11.9.1_db0@0.3.1_b_de99e2b912363472fd0b82a59600cdff/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}